export default __webpack_public_path__ + "static/media/taxBG.49ca578e.svg";